import type { SanitizeUserInputOptions } from '~/utils/sanitize-user-input';
import { forwardRef } from 'react';
import { sanitizeUserInput } from '~/utils/sanitize-user-input';
import { ImageExpander } from '~/features/common/components/ImageExpander';
import { FormattedRichTextContent } from './RichTextContent.styles';

export interface RichTextContentProps {
  children: string | null | undefined;
  sanitizeOptions?: SanitizeUserInputOptions;
  customElementStyles?: string;
  className?: string;
}

export const RichTextContent = forwardRef<HTMLDivElement, RichTextContentProps>(
  ({ className, children, sanitizeOptions = { allowSafeTags: true }, customElementStyles }, forwardedRef) => (
    <ImageExpander>
      <FormattedRichTextContent
        ref={forwardedRef}
        className={className}
        $customStyles={customElementStyles}
        dangerouslySetInnerHTML={{
          __html: sanitizeUserInput(children, sanitizeOptions),
        }}
      />
    </ImageExpander>
  ),
);
